function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.688,3.046H4.493c-0.697,0-1.262,0.572-1.262,1.277v15.168c0,0.704,0.565,1.278,1.262,1.278h15.196 c0.696,0,1.266-0.574,1.266-1.278V4.323C20.954,3.619,20.385,3.046,19.688,3.046z M8.587,18.237H5.96V9.779h2.631v8.458H8.587z  M7.274,8.624c-0.842,0-1.523-0.684-1.523-1.523c0-0.838,0.681-1.523,1.523-1.523c0.838,0,1.523,0.686,1.523,1.523 C8.797,7.944,8.117,8.624,7.274,8.624z M18.434,18.237h-2.626v-4.114c0-0.981-0.02-2.243-1.365-2.243 c-1.368,0-1.578,1.067-1.578,2.171v4.186h-2.627V9.779h2.521v1.155h0.035c0.353-0.665,1.211-1.364,2.488-1.364 c2.659,0,3.152,1.753,3.152,4.031V18.237z"
});

function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.851760b5.svg";
export { ForwardRef as ReactComponent };